<template>
  <div class="mp3-tool">
    <img src="@/assets/image/zanting.png" class="audio-image" v-if="playStatus" alt="" @click="play()">
    <img src="@/assets/image/bofang.png" class="audio-image" v-else alt="" @click="play()">
    <div style="display: flex;align-items: center;">
      <el-select size="mini" v-model="playbackRate" placeholder="请选择" @change="changePlaybackRate">
        <el-option
          v-for="item in playbackRates"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>

    <div class="audio_container">
      <div class="audio_container_box">
        <div class="audio_container_box_jindu progress-container" @click="seek($event)">
          <div class="jindu" :style="{ width: scrollerwidth }"></div>
        </div>
        <div class="audio_container_box_time">{{ timeLength }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    srcUrl: {
      default: ""
    }
  },

  data() {
    return {
      audio:         null,
      playStatus:    false,//播放状态
      duration:      0,  //音频时长
      left:          0,//剩余时长
      scrollerwidth: "0%",      //进度条
      rafId:         null,
      playbackRate: 1.0,
      playbackRates: [
        {
          label: 'x2.0',
          value: 2.0
        },
        {
          label: 'x1.5',
          value: 1.5
        },
        {
          label: 'x1.25',
          value: 1.25
        },
        {
          label: 'x1.0',
          value: 1.0
        },
        {
          label: 'x0.75',
          value: 0.75
        },
        {
          label: 'x0.5',
          value: .5
        }
      ]
    }
  },
  computed: {
    timeLength: {
      get() {
        return this.convertToTime(parseInt(this.left));
      },
      set(value) {
        return parseInt(value)
      }
    }
  },
  watch:    {
    left:   {
      handler(newValue) {
        this.timeLength = this.convertToTime(parseInt(newValue))
        this.scrollerwidth = this.computedPer()
      }
    },
    srcUrl: {
      handler() {
        this.initAudio()
      }
    }
  },

  created() {
    this.initAudio()
  },
  destroyed() {
    this.destroyAudio();
  },
  methods: {
    cancelProgressLoop() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
    },
    startProgressLoop() {
      this.cancelProgressLoop();
      const tick = () => {
        if (!this.audio) {
          return;
        }
        this.syncProgress();
        if (!this.audio.paused && !this.audio.ended) {
          this.rafId = requestAnimationFrame(tick);
        }
      };
      this.rafId = requestAnimationFrame(tick);
    },
    destroyAudio() {
      this.cancelProgressLoop();
      if (!this.audio) {
        this.duration = 0;
        this.left = 0;
        this.scrollerwidth = '0%';
        this.playStatus = false;
        return;
      }
      this.audio.pause();
      this.audio.removeEventListener('loadedmetadata', this.syncDuration);
      this.audio.removeEventListener('durationchange', this.syncDuration);
      this.audio.removeEventListener('canplay', this.syncDuration);
      this.audio.removeEventListener('canplaythrough', this.syncDuration);
      this.audio.removeEventListener('progress', this.syncDuration);
      this.audio.removeEventListener('timeupdate', this.syncProgress);
      this.audio.removeEventListener('play', this.handlePlay);
      this.audio.removeEventListener('pause', this.handlePause);
      this.audio.removeEventListener('ended', this.handleEnded);
      this.audio.src = '';
      this.audio.load();
      this.audio = null;
      this.duration = 0;
      this.left = 0;
      this.scrollerwidth = '0%';
      this.playStatus = false;
    },
    handlePlay() {
      this.playStatus = true;
      this.startProgressLoop();
      this.$emit('showPlayStatus', this.playStatus);
    },
    handlePause() {
      this.playStatus = false;
      this.cancelProgressLoop();
      this.syncProgress();
      this.$emit('showPlayStatus', this.playStatus);
    },
    handleEnded() {
      this.playStatus = false;
      this.cancelProgressLoop();
      this.left = 0;
      this.scrollerwidth = '100%';
      this.$emit('showPlayStatus', this.playStatus);
    },
    syncDuration() {
      if (!this.audio || !Number.isFinite(this.audio.duration) || this.audio.duration <= 0) {
        return;
      }
      this.duration = Math.max(Math.ceil(this.audio.duration), 0);
      this.left = Math.max(this.audio.duration - this.audio.currentTime, 0);
      this.scrollerwidth = this.computedPer();
    },
    syncProgress() {
      if (!this.audio) {
        return;
      }
      const rawDuration = this.audio.duration;
      if (Number.isFinite(rawDuration) && rawDuration > 0) {
        this.duration = Math.max(Math.ceil(rawDuration), 0);
        this.left = Math.max(rawDuration - this.audio.currentTime, 0);
      } else if (this.duration > 0) {
        this.left = Math.max(this.duration - this.audio.currentTime, 0);
      }
      this.scrollerwidth = this.computedPer();
    },
    seek(event) {
      if (this.audio && this.duration > 0) {
        const progressContainer = this.$el.querySelector('.progress-container');
        const rect = progressContainer.getBoundingClientRect();
        const offsetX = event.clientX - rect.left;
        const width = rect.width;
        const newTime = (offsetX / width) * this.duration;
        this.audio.currentTime = newTime;
        this.syncProgress();
      }
    },
    changePlaybackRate() {
      if (this.audio) {
        this.audio.playbackRate = this.playbackRate;
        this.syncProgress();
      }
    },
    //初始化音频文件
    initAudio() {
      this.destroyAudio();
      if (this.srcUrl === "") {
        return;
      }
      const audio = new Audio();
      audio.preload = 'auto';
      audio.src = this.srcUrl;
      audio.playbackRate = this.playbackRate;
      audio.addEventListener('loadedmetadata', this.syncDuration);
      audio.addEventListener('durationchange', this.syncDuration);
      audio.addEventListener('canplay', this.syncDuration);
      audio.addEventListener('canplaythrough', this.syncDuration);
      audio.addEventListener('progress', this.syncDuration);
      audio.addEventListener('timeupdate', this.syncProgress);
      audio.addEventListener('play', this.handlePlay);
      audio.addEventListener('pause', this.handlePause);
      audio.addEventListener('ended', this.handleEnded);
      audio.load();
      this.audio = audio;
    },
    stop() {
      if (!this.audio) {
        return;
      }
      this.audio.pause();
      this.audio.currentTime = 0;
      this.playStatus = false
      this.left = this.duration
      this.scrollerwidth = '0%'
      this.cancelProgressLoop();
      this.$emit("showPlayStatus", this.playStatus);
    },
    //播放暂停
    play() {
      if (this.audio === null) {
        alert("请配置音频资源");
        return
      }
      if (this.playStatus) {
        this.audio.pause()
      } else {
        this.audio.playbackRate = this.playbackRate;
        this.startProgressLoop();
        this.audio.play().then(() => {
          this.syncDuration();
          this.syncProgress();
        }).catch(() => {
          this.cancelProgressLoop();
          this.playStatus = false;
          this.$emit("showPlayStatus", this.playStatus);
        })
      }
    },
    convertToTime(times) {
      if (typeof times === 'number') {
        if (times <= 0) {
          return '00:00:00';
        } else {
          let hh = parseInt(times / 3600); //小时
          let shh = times - hh * 3600;
          let ii = parseInt(shh / 60);
          let ss = shh - ii * 60;
          return (hh < 10 ? '0' + hh : hh) + ':' + (ii < 10 ? '0' + ii : ii) + ':' + (ss < 10 ? '0' + ss : ss);
        }
      } else {
        return '00:00:00';
      }
    },
    computedPer() {
      if (!this.duration) {
        return '0%';
      }
      let per = parseInt((this.duration - this.left) / this.duration * 100)
      return per + "%";
    }
  }
}
;
</script>
<style scoped>
.mp3-tool {
  display: flex;
}

.audio-image {
  width: 45px;
  height: 45px;
  margin-right: 10px;
}

.audio_container {
  padding-left: 20px;
  width: 100%;
}

.audio_container_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.audio_container_box_jindu {
  width: 100%;
  height: 6px;
  border-radius: 5px;
  overflow: hidden;
  background: rgba(238, 238, 238, 1);
  margin-right: 10px;
}

.jindu {
  height: 100%;
  border-radius: 5px;
  background: rgba(246, 112, 75, 1);
  transition-duration: 1s;
}

.audio_container_box_time {
  margin-right: 10px;
}
.el-select {
  width: 80px;
}
</style>
